import React, {memo} from 'react'
import TextField from '@material-ui/core/TextField';

const AppInputCel = memo(({id, name, label, value='', required = false, onChange, block = true, disabled=false}) => {

    let style = {};

    if (block) {
        style.width = '100%'
    }

    return (
        <TextField
            type='number'
            inputProps={{maxLength: 10}}
            required={required}
            value={value}
            style={style}
            disabled={disabled}
            onChange={onChange}
            id={id}
            name={name}
            label={label}
            variant="outlined"/>
    );
})
export default AppInputCel